import React, { Component } from 'react'
import styled from 'styled-components'
import Switch from 'components/UI/Switch'
import TextInput from 'components/UI/TextInput'
import Dropdown from 'components/UI/Dropdown'
import { MetadataObj } from 'store/types'
import { IForm } from '../EstimateForm'

interface Props {
  relationships?: object[]
  genders?: object[]
  errors: MetadataObj
  onChangeInput: (name: string, value: string | null) => void
  onRemoveElement?: (id: any) => void
  onShowPatientSubscriberChange?: (showPatientSubscriber: boolean) => void
  form: IForm
  showPatientSubscriberFromParent?: boolean
}
interface IFormState {
  showPatientSubscriber: boolean
}

const enableGender = process.env.REACT_APP_ENABLE_GENDER === 'true'

class PatientInfo extends Component<Props, IFormState> {
  constructor(props: Props) {
    super(props)

    this.state = {
      showPatientSubscriber: true
    }
  }

  componentDidMount(): void {
    const { showPatientSubscriberFromParent } = this.props
    const { showPatientSubscriber } = this.state
    if (
      showPatientSubscriberFromParent !== undefined &&
      showPatientSubscriber !== showPatientSubscriberFromParent
    ) {
      this.setState({ showPatientSubscriber: showPatientSubscriberFromParent })
    }
  }

  togglePatientSubscribers = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ showPatientSubscriber: !this.state.showPatientSubscriber })
    this.props.onShowPatientSubscriberChange &&
      this.props.onShowPatientSubscriberChange(
        !this.state.showPatientSubscriber
      )
  }

  render() {
    const { showPatientSubscriber } = this.state
    const {
      onChangeInput,
      relationships,
      genders,
      errors,
      form: {
        payer,
        dependent,
        firstName,
//        middleInitial,
        lastName,
        dob,
        gender,
        relationship
      }
    } = this.props

    return (
      <Form>
        <div>
          <FormTitle>Patient Information</FormTitle>
          <TextInput
            name={'dependent.firstName'}
            value={dependent ? dependent.firstName : ''}
            label={'First Name'}
            placeholder={'Enter First Name'}
            errorLabel={errors.firstName2 || ''}
            handleChange={onChangeInput}
          />
{/*           <TextInput
            name={'dependent.middleInitial'}
            value={dependent ? dependent.middleInitial : ''}
            label={'Middle Initial'}
            placeholder={'Enter Middle Initial'}
            errorLabel={errors.middleInitial2 || ''}
            handleChange={onChangeInput}
          />
 */}          <TextInput
            name={'dependent.lastName'}
            value={dependent ? dependent.lastName : ''}
            label={'Last Name'}
            placeholder={'Enter Last Name'}
            errorLabel={errors.lastName2 || ''}
            handleChange={onChangeInput}
          />
          {(payer.requiredMemberId || payer.dobRequired) &&
          <TextInput
            name={'dependent.dob'}
            value={dependent ? dependent.dob : ''}
            label={'Date of Birth'}
            type={'date'}
            placeholder={'Enter MMDDYYYY'}
            errorLabel={errors.dob2 || ''}
            handleChange={onChangeInput}
          />}

          {enableGender && <Dropdown
            name={'dependent.gender'}
            options={genders}
            value={dependent ? dependent.gender : null}
            label={'Gender'}
            placeholder={'Select Gender'}
            hideControl={true}
            onSelect={onChangeInput}
          />}
        </div>
        {payer.requiredMemberId &&
        <Switch
          label={'The Patient is also the Subscriber'}
          checked={ showPatientSubscriber }
          handleChange={this.togglePatientSubscribers}
        />}
        {!showPatientSubscriber && (
          <PatientFormBlock>
            <FormTitle>Subscriber Information</FormTitle>
            <TextInput
              name={'firstName'}
              label={'First Name'}
              value={firstName}
              placeholder={'Enter First Name'}
              errorLabel={errors.firstName || ''}
              handleChange={onChangeInput}
            />
{/*             <TextInput
              name={'middleInitial'}
              label={'Middle Inital'}
              value={middleInitial}
              placeholder={'Enter Middle Initial'}
              errorLabel={errors.middleInitial || ''}
              handleChange={onChangeInput}
            /> */}
            <TextInput
              name={'lastName'}
              label={'Last Name'}
              value={lastName}
              placeholder={'Enter Last Name'}
              errorLabel={errors.lastName || ''}
              handleChange={onChangeInput}
            />
            <TextInput
              name={'dob'}
              label={'Date of Birth'}
              value={dob}
              type={'date'}
              placeholder={'Enter MMDDYYYY'}
              errorLabel={errors.dob || ''}
              handleChange={onChangeInput}
            />

            <Dropdown
              name={'gender'}
              options={genders}
              value={gender}
              label={'Gender'}
              placeholder={'Select Gender'}
              hideControl={true}
              onSelect={onChangeInput}
            />

            <Dropdown
              name={'relationship'}
              options={relationships}
              value={relationship}
              label={'Relationship to Patient'}
              placeholder={'Select Relationship'}
              onSelect={onChangeInput}
            />
          </PatientFormBlock>
        )}
      </Form>
    )
  }
}

export default PatientInfo

const PatientFormBlock = styled.div`
  padding-top: 3rem;
`
const FormTitle = styled.h2`
  margin-bottom: 2rem;
`
const Form = styled.form`
  max-width: 560px;
`
/*
  <div>
  <FormTitle>Patient Information</FormTitle>
<TextInput
name={'dependent.firstName'}
value={dependent ? dependent.firstName : ''}
label={'First Name'}
placeholder={'Enter First Name'}
errorLabel={
  showPatientSubscriber
  ? errors.firstName2 || ''
  : errors.firstName || ''
}
handleChange={onChangeInput}
/>
<TextInput
  name={'dependent.middleInitial'}
  value={dependent ? dependent.middleInitial : ''}
  label={'Middle Initial'}
  placeholder={'Enter Middle Initial'}
  errorLabel={
    showPatientSubscriber
      ? errors.middleInitial2 || ''
      : errors.middleInitial || ''
  }
  handleChange={onChangeInput}
/>
<TextInput
name={'dependent.lastName'}
value={dependent ? dependent.lastName : ''}
label={'Last Name'}
placeholder={'Enter Last Name'}
errorLabel={
  showPatientSubscriber
  ? errors.lastName2 || ''
  : errors.lastName || ''
}
handleChange={onChangeInput}
/>
<TextInput
  name={'dependent.dob'}
  value={dependent ? dependent.dob : ''}
  label={'Date of Birth'}
  type={'date'}
  placeholder={'Enter MMDDYYYY'}
  errorLabel={
    showPatientSubscriber ? errors.dob2 || '' : errors.dob || ''
  }
  handleChange={onChangeInput}
/>

<Dropdown
name={showPatientSubscriber ? 'gender' : 'dependent.gender'}
options={genders}
value={dependent ? dependent.gender : null}
label={'Gender'}
placeholder={'Select Gender'}
hideControl={true}
onSelect={onChangeInput}
/>
</div>
 */
